/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'thumbs-down-active': {
    width: 18,
    height: 17,
    viewBox: '0 0 18 17',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10.553 16.412A1 1 0 0 1 9.64 17c-.866 0-1.7-.339-2.318-.946a3.232 3.232 0 0 1-.968-2.304v-2H3.046a2.544 2.544 0 0 1-1.921-.854 2.492 2.492 0 0 1-.596-2.023l1.052-6.75v-.001c.092-.6.402-1.143.866-1.532A2.54 2.54 0 0 1 4.098 0h10.878c.664 0 1.304.26 1.779.727.475.467.745 1.105.745 1.773v5.25c0 .668-.27 1.306-.745 1.773a2.537 2.537 0 0 1-1.78.727h-1.64l-2.783 6.162ZM13.689 2v6.25h1.287c.144 0 .279-.056.376-.152a.488.488 0 0 0 .148-.348V2.5a.488.488 0 0 0-.148-.348.537.537 0 0 0-.376-.152h-1.287Z" _fill="#4990E2"/>'
  }
})
